import Header from "../components/Header";
import React from "react";
import ChangePassword from "../components/profile/ChangePassword";
import Footer from "../components/Footer";

function ChangePasswordPage() {
  return (
    <div>
        <Header />

      <ChangePassword />
        <Footer/>
    </div>
  );
}

export default ChangePasswordPage;
